import { takeEvery, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { InitiativeActions } from '../actions';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { getErrorForToastr } from '../utils/error-adapter';
import { RouteUrls } from '../configs/routeUrls';

const initiativeUrl = '/api/initatives';

export function* watchCreateInitiative() {
	yield takeEvery(InitiativeActions.CreateInitiativeAction.Request, createInitiative);
}
function* createInitiative(action) {
	try {
		yield call(createInitiativeRequest, action.payload);
		yield put({
			type: InitiativeActions.CreateInitiativeAction.Success
		});
		toastr.success(
			'Inicjatywa obywatelska',
			'Inicjatywa obywatelska została przekazana do odpowiednich wydziałów urzędu'
		);

		yield put(push(`${RouteUrls.App.main}`));
	} catch (err) {
		yield put({ type: InitiativeActions.CreateInitiativeAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd wysyłania inicjatywy obywatelskiej',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas wysyłania inicjatywy obywatelskiej.'
		);
	}
}
function createInitiativeRequest(initiative) {
	return axios.post(`${initiativeUrl}`, initiative).then((response) => response.data).catch((err) => {
		throw err;
	});
}
export function* watchCreateConsultationInitiative() {
	yield takeEvery(InitiativeActions.CreateConsultationInitiativeAction.Request, createConsultationInitiative);
}
function* createConsultationInitiative(action) {
	try {
		const project = yield call(createConsultationInitiativeRequest, action.payload);
		yield put({
			type: InitiativeActions.CreateConsultationInitiativeAction.Success,
			payload: project
		});
		toastr.success(
			'Formularz kontaktowy konsultacji',
			'Wiadomość została przekazana do odpowiednich wydziałów urzędu'
		);
	} catch (err) {
		yield put({ type: InitiativeActions.CreateConsultationInitiativeAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd wysyłania formularza kontaktowego konsultacji',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas wysyłania wiadomości'
		);
	}
}
function createConsultationInitiativeRequest(initiative) {
	return axios.post(`${initiativeUrl}/consultations`, initiative).then((response) => response.data).catch((err) => {
		throw err;
	});
}
